import { render } from "./MachineInfo.vue?vue&type=template&id=2cde37a1&scoped=true"
import script from "./MachineInfo.vue?vue&type=script&lang=js"
export * from "./MachineInfo.vue?vue&type=script&lang=js"

import "./MachineInfo.vue?vue&type=style&index=0&id=2cde37a1&lang=scss&scoped=true"

import exportComponent from "F:\\Hongjia\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cde37a1"]])

export default __exports__